export default (value, decimals = 2) => {
  if (value === null || value === undefined) {
    return '-';
  }

  if (Number.isNaN(value)) {
    return 0;
  }

  if (isNaN(value)) {
    return value;
  }

  const formatter = new Intl.NumberFormat('es-AR', {
    style: 'decimal',
    minimumFractionDigits: decimals,
  });

  return formatter.format(value);
};
